import React from "react";
import { FiMail, FiPhone } from "react-icons/fi";
import "./BookingPage.scss";

const BookingPage = () => {
  return (
    <section className="booking">
      <div className="booking__card">
        <h1 className="booking__title">Contacto:</h1>
        <p className="booking__subtitle">
          Para shows, eventos y colaboraciones:
        </p>

        <div className="booking__contact">
          <FiMail />
          <a href="mailto:info@flowmune.com">
            info@flowmuñe.com
          </a>
        </div>
        <div className="booking__contact">
          <FiMail />
          <a href="mailto:chrisrosase@icloud.com">
            chrisrosase@icloud.com
          </a>
        </div>

        <div className="booking__contact">
          <FiPhone />
          <a href="https://wa.link/m2odmb">
            +34 722355841
          </a>
        </div>
        <p className="booking__hint">
          Respuesta en menos de 24 horas.
        </p>
      </div>
    </section>
  );
};

export default BookingPage;